<section class="animated fadeIn bg-gray ">
    <div class="breadcrumbArea">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/approval"> <i class="hdr-home"></i> </a></li>
                            <li class="breadcrumb-item active" aria-current="page">On-Behalf Delegation Request</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>


    <div class="container mt15">
        <div class="row">
            <div class="col-md-12">
                <p class="appHead mb-8">On-Behalf Employee Name/SAP-ID</p>
            </div>
            <div class="col-md-12">
                <div class="empSearch FormField2">
                    <!-- <p-autoComplete [(ngModel)]="searchOnBehalfEmployee" [suggestions]="finalOnBehalfEmp"
                        (completeMethod)="bindOnBehalfEmployee()" [size]="30" [minLength]="1"
                        placeholder="Search By Name or User ID" panelStyleClass="panelClass"></p-autoComplete>
                    <span class="hdr-search"></span> -->
                    <p-autoComplete [(ngModel)]="searchOnBehalfEmployee" [suggestions]="filteredBrands"
                        (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1"
                        placeholder="Search By Name or User ID" panelStyleClass="panelClass"
                        (onKeyUp)="FetchEmployeeSuggestion($event)" (onSelect)="updateDelegateeId($event)">
                    </p-autoComplete>
                    <span class="hdr-search"></span>
                    <label *ngIf="Validationonbehalfemployee" style="color: hsl(0, 100%, 50%);">*On-Behalf employee
                        missing.</label>
                </div>
            </div>
        </div>
    </div>
    <section class="height-calc-on-behalf">
        <div class="container mt-24 mb30">
            <div class="row">
                <div class="col-md-3 col-sm-3 mb-24">
                    <p class="appHead f-18 mb-12">Select Application(s)</p>
                    <div class="whiteBox2">
                        <!-- <div class="inputArea">
                        <input type="text" name="search" [(ngModel)]="searchTxt" (keyup)="changeEvt()" placeholder="Type here to search" autocomplete="off" pInputText>
                        <span class="icon-search"></span>
                        <span class="hcl-close" [hidden]="closebtn" (click)="clearInput()"></span>
                    </div> -->
                        <div class="selecteDiv2">
                            <p class="appSelchead">{{NoOfSelectedApp}} Application Selected</p>
                            <ul class="selUl" (click)="RemoveSelectedApp($event)">
                                <li *ngFor='let app of selectedApps'>{{app.AppName|uppercase}}</li>
                            </ul>
                        </div>
                        <p class="appSelchead bt-1">Application List</p>
                        <div class="leftSelectAll">
                            <ul class="selectRow">
                                <!-- <li>
                                <label class="checkbox-label-role customLabel">
                                    <input type="checkbox" class="check1" [(ngModel)]="isCheckAllApp"
                                        (change)="CheckAllApplication($event)">
                                    <span class="checkbox-custom">Select All</span>
                                    <span class="customCheck"></span>
                                </label>
                            </li> -->
                                <li *ngFor='let appRole of appRoleAndSubRoles'>
                                    <label class="checkbox-label-role customLabel">
                                        <input type="checkbox" value="{{appRole.AppId}}" [(ngModel)]="appRole.checkapp"
                                            checked="" (change)="onSelectApp(appRole.AppName,appRole.AppId,$event)"
                                            [ngModelOptions]="{standalone: true}">
                                        <span class="checkbox-custom">{{appRole.AppName|uppercase}}</span>
                                        <span class="customCheck"></span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 col-sm-9">
                    <div class="row mb-14">
                        <div class="col-md-4 col-sm-4">
                            <p class="appHead f-18">Provide Application wise Details</p>
                        </div>
                        <div class="col-md-8 col-sm-8">
                            <ul class="sameUl">
                                <li>Same for All:</li>
                                <li>
                                    <label class="checkbox-label">
                                        <input type="checkbox" (click)="toggleDelegate()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText">Delegate to </h4>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-label ">
                                        <input type="checkbox" (click)="toggleDuration()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText"> Duration </h4>
                                    </label>
                                </li>
                                <li>
                                    <label class="checkbox-label ">
                                        <input type="checkbox" (click)="toggleRemarks()">
                                        <span class="checkbox-custom mr-t-2"></span>
                                        <h4 class="checkText"> Remarks </h4>
                                    </label>
                                </li>
                                <li>
                                    <p class="expColText" (click)="openAll()">
                                        <!-- <span (click)="txtTgl = !txtTgl">{{txtTgl ? "Collapse All" : "Expand All"}}</span> -->
                                        <span class="hdr-accordionDown"></span>
                                        <span class="hdr-accordionUp"></span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="padding0 accordionTab">
                        <p-accordion [activeIndex]="index" *ngFor='let selectRole of selectedApps'
                            expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-up">
                            <p-accordionTab [selected]="true">
                                <p-header class="headerA"> {{selectRole.AppName|uppercase}}
                                    <span class="subHeader"> ({{NoOfSelectedRoleWithoutSubRole}} roles selected) </span>
                                </p-header>
                                <!--With Out Sub Roles-->
                                <ul class="provideDiv" *ngIf="!selectRole.IsAdvDelegated">
                                    <li>
                                        <label class="checkbox-label ">
                                            <input type="checkbox" [(ngModel)]="SelectAllRoles"
                                                (change)="SelectAllRole($event)">
                                            <span class="checkbox-custom"></span>
                                            <h4 class="checkText tableHd"> Roles <span> (without Sub-Roles) </span>
                                            </h4>
                                        </label>
                                        <ul class="selectRow mb-30">
                                            <li *ngFor='let role of selectRole.CDS_GetRoleAndSubRole;let i=index'>
                                                <label class="checkbox-label-role customLabel">
                                                    <input type="checkbox" [name]="'mes_' + i"
                                                        [(ngModel)]="role.checkapp"
                                                        (change)="addRoleEvent(role.AppId,role.AppRoleID)">
                                                    <span
                                                        class="checkbox-custom mrt-2">{{role.RoleName|uppercase}}</span>
                                                    <span class="customCheck mrt-1"></span>
                                                </label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <!-- With Sub Roles -->
                                <ul class="provideDiv" *ngIf="selectRole.IsAdvDelegated">
                                    <li *ngFor='let subrole of selectRole.CDS_GetRoleAndSubRole;let p=index'>
                                        <h4 class="checkText tableHd rolesHead"> Roles <span> (along with Sub-Roles)
                                            </span>
                                            <i class="icon-info" triggers="mouseenter:mouseleave" placement="bottom"
                                                container="body" [popover]="subRoleTemp"></i>
                                        </h4>
                                        <label class="checkbox-label">
                                            <!-- <input type="checkbox" [(ngModel)]="SelectAllSubRoles" (change)="SelectAllWithSubRole(subrole.SubRoleName)"> -->
                                            <input type="checkbox" name="'subRole_' + p"
                                                [(ngModel)]="subrole.SelectAllRoles"
                                                (change)="SelectAllWithSubRole($event,subrole.AppId,subrole.AppRoleID)">
                                            <span class="checkbox-custom"></span>
                                            <h4 class="checkText tableHd grpLb"> {{subrole.RoleName|uppercase}} </h4>
                                        </label>
                                        <ul class="selectRow mb-30">
                                            <li *ngFor='let subsubrole of subrole.SubRoleName;let k=index'>
                                                <label class="checkbox-label-role customLabel">
                                                    <input type="checkbox" name="subsubrole+k"
                                                        [(ngModel)]="subsubrole.checkapp"
                                                        (change)="addSubRoleEvent(subsubrole.AppId,subsubrole.RollId,subsubrole.Subrolid,subsubrole.SubRoleName,subsubrole.SubRoleCode)">
                                                    <span class="checkbox-custom">
                                                        {{subsubrole.SubRoleName}}
                                                    </span> <span class="customCheck"></span> </label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>


                                <div class="bootomSection">
                                    <div class="row">
                                        <div class="col-md-4" [class.delegateHide]="delegateHideDiv">
                                            <label>Delegate To</label>
                                            <div class="empSearch FormField2">
                                                <p-autoComplete [(ngModel)]="searchText" [suggestions]="filteredBrands"
                                                    (completeMethod)="filterBrands($event)" [size]="30" [minLength]="1"
                                                    placeholder="Search by Name or SAP ID" panelStyleClass="panelClass"
                                                    (onKeyUp)="OnKeyUpDelegative($event,selectRole.AppId)"
                                                    (onSelect)="updateAdvanceDelegatee($event,selectRole.AppId)">
                                                </p-autoComplete>
                                                <span class="hdr-search"></span>
                                                <ng-template let-brand pTemplate="item">
                                                    <div class="ui-helper-clearfix">
                                                        <div>{{brand}}</div>
                                                    </div>
                                                </ng-template>
                                                <label *ngIf="ValidationSelectDelegetee" style="color: red;">*Select
                                                    Delegatee</label>
                                            </div>
                                        </div>

                                        <div class="col-md-8 col-sm-8 cstmDD calender"
                                            [class.durationHide]="durationHideDiv">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Duration</label>
                                                    <div class="radioWarp">
                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="1-Month"
                                                                [(ngModel)]="ingredient" inputId="ingredient1"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient1" class="">1 Month</label>
                                                        </div>

                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="3-Month"
                                                                [(ngModel)]="ingredient" inputId="ingredient2"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient2" class="">3 Month</label>
                                                        </div>

                                                        <div class="d-flex align-items-center radioBtn">
                                                            <p-radioButton name="Duration" value="1-Year"
                                                                [minDate]="minDate" [(ngModel)]="ingredient"
                                                                inputId="ingredient3"
                                                                (onClick)="onDatesRangeFilterSelected()">
                                                            </p-radioButton>
                                                            <label for="ingredient3" class="">1 Year</label>
                                                        </div>
                                                    </div>
                                                    <label *ngIf="ValidationRadioBtn" style="color: red;">*Select
                                                        Duration</label>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="FormField calenderFild mt-26">
                                                        <p-calendar appendTo="body" dateFormat="dd-M-y"
                                                            [numberOfMonths]="2" placeholder="Date Range"
                                                            [(ngModel)]="rangeDates" selectionMode="range"
                                                            [readonlyInput]="true" [showIcon]="true"
                                                            (onSelect)="moveDate()"></p-calendar>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-16">
                                        <div class="col-md-12" [class.remarksHide]="remarksHideDiv">
                                            <div class="form-area text-center">
                                                <textarea class="form-control remarks"
                                                    placeholder="Due to non-availability in office."
                                                    (change)="onAdvanceRemarks($event.target.value,selectRole.AppId)"></textarea>
                                                <div class="mickWarp"><span class="hdr-mick"></span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-16">
                                        <div class="col-md-12">
                                            <label>Approval Mail</label>
                                            <!-- <p-fileUpload mode="basic" chooseLabel="File Upload" name="demo[]" url="https://www.primefaces.org/cdn/api/upload.php" (uploadHandler)="onUploadDossier($event,selectRole.AppId)" accept=".jpg,.jpeg,.png,.pdf,.msg,.docx,.doc" maxFileSize="1000000" [auto]="true"  (onRemove)="RemoveItem($event)"></p-fileUpload> -->
                                            <p-fileUpload mode="basic" chooseLabel="File Upload" name="demo[]"
                                                url="https://www.primefaces.org/cdn/api/upload.php"
                                                accept=".jpg,.jpeg,.png,.pdf,.msg,.docx,.doc" maxFileSize="1000000" 
                                                [auto]="false" (onSelect)="onUploadDossier($event)" ></p-fileUpload>
                                        </div>
                                    </div>
                                    <div class="row ml-dlg-5">
                                        <div class="col-md-12 mt-16 mb-24">
                                            <label class="checkbox-label ">
                                                <input type="checkbox" [(ngModel)]="DelegatorChecked"
                                                    (change)="onDelegatorchecked($event.target.checked)">
                                                <span class="checkbox-custom mr-l-10"></span>
                                                <h4 class="checkText">Delegator will continue to be responsible for all actions taken by Delegator</h4>
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <label *ngIf="DelegatorConsen" style="color: hsl(0, 100%, 50%);">*Please select Delegator Condition</label>
                                    </div>
                                </div>
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>


<div class="text-center glb-btn pb-24 pt-24 pos-sticky border-t-1-gray">
    <button class="btn secondry-button" (click)="reloadWindow()">Cancel</button>
    <button (click)="onSubmit();" type="button" class="btn primary-button"
        [disabled]="! isSubmitbuttonshow">Submit</button>
    <!-- <button (click)="rejectModal.show();onSubmit();" type="button" class="btn primary-button" [disabled]="! isSubmitbuttonshow">Submit</button> -->
</div>



<!-- Roles Popover  -->
<ng-template #revokeTemplate>
    <div class="Revoke provideDiv">
        <ul class="selectRow">
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        CORP-HR-HEAD
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        CUST-ROLE
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        SBU-FIN
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        FIN-SUPER
                    </span> </label>
            </li>
            <li>
                <label class="checkbox-label-role">
                    <input type="checkbox">
                    <span class="checkbox-custom">
                        FIN-REGION
                    </span> </label>
            </li>
        </ul>
    </div>
</ng-template>

<!-- along with Sub-Roles Popover info  -->
<ng-template #subRoleTemp>
    <div class="Revoke provideDiv">
        Check Role's and Application.
    </div>
</ng-template>

<!-- Reject Modal Box Start  -->
<div bsModal #rejectModal="bs-modal" class="modal fade myModal" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-body d-flex justify-content-center">
                <div class="mCell text-center">
                    <span class="alertIcon"> <i class="hdr-attention"></i> </span>
                    <h3>Are you sure you want to submit request?</h3>
                    <div class="glb-btn mt-40">
                        <button (click)="rejectModal.hide();" class="btn secondry-button">No</button>
                        <button type="button" class="btn primary-button"
                            (click)="rejectModal.hide(); OnBehalfSubmit();">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Approve Modal Box Start  -->
<!-- <ng-template #approvedModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
            <p class="">Request has been submitted successfully.</p>
        </div>
    </div>
</ng-template> -->

<!-- <ng-template #alertInvalidSapid>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide();" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Invalid SAP ID, Enter valid SAP ID</h3>
            <div class="glb-btn">
            </div>
        </div>
    </div>
</ng-template> -->

<!-- <ng-template #alertSapid>
    <div class="mtable">
        <div class="mCell">
            <h4 (click)="modalRef.hide();" class="closeS"><i class="icon-cancel"></i></h4>
            <span class="alertIcon"> <img [src]="alertIcon" /> </span>
            <h3>Please Enter Onbehalf Employee SAP ID </h3>
            <div class="glb-btn"> -->
<!-- <button (click)="modalRef.hide(); " class="primary-button">OK</button> -->
<!-- </div>
        </div>
    </div>
</ng-template> -->

<ng-template #alertInvalidSapid>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="errorIcon" /> </span>
            <p class="">Invalid SAP ID, Enter valid SAP ID</p>
        </div>
    </div>
</ng-template>

<ng-template #alertSapid>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="errorIcon" /> </span>
            <p class="">Please Enter Onbehalf Employee SAP ID</p>
        </div>
    </div>
</ng-template>

<ng-template #alertOnBehalf>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="errorIcon" /> </span>
            <p class="">Don't have access to delegate</p>
        </div>
    </div>
</ng-template>
<ng-container *ngIf="visibleFile">
    <div class="toast-warp" #quick>
        <p>{{errorOnbehalfDelegation}}</p>
        <button (click)="quick.hidden = !quick.hidden;OnClick()" type="button" aria-label="Close"
            class="btn-close close pull-right"><span aria-hidden="true" class="hdr-cancel"></span></button>
    </div>
</ng-container>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<p-dialog [(visible)]="displayFailRequest" position="top" [draggable]="false" [modal]="true" styleClass="confirmMsg">
    <div class="thankMsg">
        <img src="assets/images/alert.svg" alt="">
        <p>Some request failed. Please try again.</p>
    </div>
</p-dialog>

<p-dialog [(visible)]="diswarmingOndehalfDele" position="top" [draggable]="false" [modal]="true"
    styleClass="confirmMsg">
    <div class="thankMsg">
        <img src="assets/images/alert.svg" alt="">
        <p>{{errorOnbehalfDelegation}}</p>
    </div>
</p-dialog>


<ng-template #alertSingleApp>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="errorIcon" /> </span>
            <p class="">Allow Single App.</p>
        </div>
    </div>
</ng-template>

<ng-template #approvedModal>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
            <!-- <pre [innerHTML]="reqStatusRemarks | safe: 'html'"></pre> -->
            <p>{{reqStatusRemarks}}</p>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="visible">
    <div class="toast-warp" #test>
        <p> {{messagetoast}} </p>
        <button (click)="test.hidden = !test.hidden;OnClick()" type="button" aria-label="Close"
            class="btn-close close pull-right"><span aria-hidden="true" ></span></button>
    </div>
</ng-container>

<ng-template #approvedModalMultiLine>
    <div class="modal-body successModal">
        <button type="button" class="btn-close close pull-right" aria-label="Close"
            (click)="modalRef?.hide(); hideSuccessMsg()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
        <div class="mtable">
            <span class="sucImg"> <img width="60" height="60" alt="approve Image" [src]="sucImg" /> </span>
            <!-- <pre [innerHTML]="reqStatusRemarks | safe: 'html'"></pre> -->
            <p *ngFor='let message of reqStatusRemarksMultiLine;'>{{message}}</p>
        </div>
    </div>
</ng-template>